import 'react-app-polyfill/ie11';
// Polyfill Web Animations
import 'web-animations-js';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'connected-react-router';
import store, {history} from './store';
import './scss/base.scss';
import 'font-awesome/css/font-awesome.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import * as serviceWorker from './serviceWorker';
import { CookiesProvider } from 'react-cookie';
import routes from './routes';

render(
    <Provider store={store}>
      <CookiesProvider>
        <ConnectedRouter history={history}>{routes}</ConnectedRouter>
      </CookiesProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
